import { PayloadAction, createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { CabinetFetchDetails, getCabinets } from "../../utilities/api-utils";

interface CabinetState {
  cabinets: string[],
  activeCabinet: string,
  loading: boolean,
  isSearching: boolean
}

const initialState: CabinetState = {
  // state default values
  cabinets: [],
  activeCabinet: "",
  loading: false,
  isSearching: false
};

export const fetchCabinets = createAsyncThunk(
  'cabinets/fetchCabinets',
  async (cabFetchDetails: CabinetFetchDetails, { signal }) => {
    const source = axios.CancelToken.source();

    signal.addEventListener('abort', () => {
      source.cancel();
    });
    
    const response = await getCabinets(cabFetchDetails.key, cabFetchDetails.organizationId, cabFetchDetails.storeId);
    return response.data;
  }
);

export const cabinetSlice = createSlice({
  name: 'Cabinet',
  initialState,
  reducers: {
    // actions for setting state
    setCabinets: (state, action: PayloadAction<string[]>) => {
      state.cabinets = action.payload;
    },
    setActiveCabinet: (state, action: PayloadAction<string>) => {
      state.activeCabinet = action.payload;
    },
    setIsSearching: (state, action: PayloadAction<boolean>) => {
      state.isSearching = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCabinets.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCabinets.fulfilled, (state, action) => {
      state.loading = false;
      for (let i = 0; i < action.payload.length; i++) {
        state.cabinets.push(action.payload[i].id);
      }
    });
    builder.addCase(fetchCabinets.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { setCabinets, setActiveCabinet, setIsSearching } = cabinetSlice.actions;
export default cabinetSlice.reducer;
